import { getAllSlides } from "../../services/apis";
import {
  createNewPage,
  createNewPageUpdate,
  createNewChildSlide,
  AddMasterSlideToDeck,
} from "../../services/apis";
import { toggleLeftPanel } from "../../utils/editorUtils/commonFunctions";
import { showErrorToast, showSuccessToast } from "../toastComponent/ToastComponent";
export const addNewChildSlide = async (
  slideID,
  setSlideID,
  currentSlide,
  setCurrentSlide,
  editor,
  appData,
  slideCount,
  childSlideCount,
  setChildSlideCount,
  navigate,
  setSaveLoading,
  setLoadSuccess,
  loadSuccess,
  setOpenPopover
) => {
  if (!loadSuccess) return;

  setSaveLoading(true);
  setLoadSuccess(false);

  const CHILDSLIDETYPE = 2;
  const POPUPTYPE = 1;

  let currentSlideChildrenLength = currentSlide.master.children.length;

  const createNewPagePaload = {
    // name: appData.deckId.name + "-ChildSlide_" + new Date().getTime(),
    name: appData.deckId.name.substring(0, 10) + "_" + new Date().getTime(),
    desc: appData.deckId.desc,
    content: {},
    thumbnail: appData.deckId.thumbnail || "https://cdn.link/image.png",
    tags: appData.deckId.tags,
    key_message: currentSlide?.master?.slideid?.key_message,
  };
  let data = "";

  const updateSlidesAndCurrentSlide = (response) => {
    let slideIDInstance = JSON.parse(JSON.stringify(slideID));
    let currentSlideInstance = JSON.parse(JSON.stringify(currentSlide));
    // let childrenFromResponse =
    //   response.data.slides[currentSlide.master.index - 1].children;
    let respChildren =
      response.data.slides[currentSlide.master.index - 1].children;
    let childrenFromResponse = [
      ...currentSlideInstance.master.children,
      respChildren[respChildren.length - 1],
    ];

    // let currentSlideIndex = slideIDInstance.findIndex(
    //   (slide) => slide.slideid?._id === currentSlide.master.slideid?._id
    // );

    let currentSlideIndex = currentSlide?.master?.index - 1;
    slideIDInstance[currentSlideIndex].children = childrenFromResponse;
    currentSlideInstance.master.children = childrenFromResponse;
    currentSlideInstance.child =
      childrenFromResponse[childrenFromResponse.length - 1];

    setCurrentSlide(currentSlideInstance);

    setSlideID(slideIDInstance);
    setChildSlideCount(slideCount + "." + childrenFromResponse.length);
    navigate(
      `/editor/${
        childrenFromResponse[childrenFromResponse.length - 1].slideid?._id
      }`
    );
    let pageVal = {
      id: childrenFromResponse[childrenFromResponse.length - 1].slideid?._id,
      styles: "{}", // or a JSON of styles
      component: "", // or a JSON of components
    };
  };
  const addChildToMasterSlide = (data) => {
    //console.log("appData", appData);
    let childPayLoad = {
      slideid: currentSlide.master.slideid?._id,
      children: [
        {
          slideid: data._id,
          index: currentSlideChildrenLength + 1,
          type: CHILDSLIDETYPE,
        },
      ],
    };
    createNewChildSlide(
      appData?.deckId?._id,
      childPayLoad,
      (response, err, errorCode) => {
        if (err) {
          showErrorToast('Child Slide creation failed. Pl try again');
          setSaveLoading(false);
        } else {
          showSuccessToast('Child Slide creation successful');
          toggleLeftPanel();
          setSaveLoading(false);
          updateSlidesAndCurrentSlide(response);
          setOpenPopover(false);
        }
      }
    );
  };
  createNewPage(createNewPagePaload, (response, err, errorCode) => {
    if (err) {
      if (errorCode === 400) {
        setSaveLoading(false);
        showErrorToast(err.response.data.error._message === "Slide validation failed"
          ? "Child name is longer than the maximum allowed limit"
          : "Child Slide creation failed. Pl try again");
      } else
      showErrorToast('Child Slide creation failed. Pl try again');
      // setLoadSuccess(true);
      // setSaveLoading(false);
      return;
    } else {
      data = response.data;
      addChildToMasterSlide(data);
    }
  });
};
const getCurrentPageIndex = (currentSlide) => {
  return currentSlide.master.children.findIndex(
    (child) => child.slideid?._id === currentSlide.child.slideid?._id
  );
};

export const navigateToNextChildAndFromParent = async ({
  currentSlide,
  setCurrentSlide,
  setChildSlideCount,
  setSlideCount,
  editor,
  navigate,
  slideID,
  setSlideID,
  inputElement,
  setcanvasWidth,
  setLoadSuccess,
  setSaveLoading,
  loadSuccess,
}) => {
  if (!loadSuccess) return;
  setLoadSuccess(false);
  setSaveLoading(true);
  let currentSlideCopy = JSON.parse(JSON.stringify(currentSlide));
  let slideIDCopy = JSON.parse(JSON.stringify(slideID));
  toggleLeftPanel();
  if (
    JSON.stringify(currentSlide.child) === "{}" &&
    currentSlide.master.children.length > 0
  ) {
    navigate(`/editor/${currentSlide.master.children[0].slideid?._id}`);
    currentSlideCopy.child = currentSlideCopy.master.children[0];
    //  console.log("currentSlideCopy", currentSlideCopy);
    setChildSlideCount(currentSlide?.master?.index + 0.1);
    setCurrentSlide(currentSlideCopy);

    // setChildSlideCount(getCurrentMasterSlideIndex(slideID, currentSlide) + 0.1);
  } else {
    // let currentPageIndex = getCurrentPageIndex(currentSlide);
    let currentChildIndex = currentSlide?.child?.index - 1;

    let lastChild = currentSlide.master.children.length - 1;

    if (currentChildIndex < lastChild) {
      navigate(
        `/editor/${
          currentSlide.master.children[currentChildIndex + 1].slideid?._id
        }`
      );
      currentSlideCopy.child =
        currentSlideCopy.master.children[currentChildIndex + 1];
      setChildSlideCount(
        currentSlide?.master?.index + "." + (currentChildIndex + 2)
      );
    }
  }
  setCurrentSlide(currentSlideCopy);
  slideIDCopy[currentSlideCopy.master.index - 1] = currentSlideCopy.master;
  setSlideID(slideIDCopy);
};
const getCurrentMasterSlideIndex = (slideID, currentSlide) => {
  return (
    slideID?.findIndex(
      (slide) => slide?.slideid?._id === currentSlide?.master?.slideid?._id
    ) + 1
  );
};
export const navigateToPrevChildAndParent = async ({
  currentSlide,
  setCurrentSlide,
  setChildSlideCount,
  setSlideCount,
  editor,
  navigate,
  slideID,
  setSlideID,

  setLoadSuccess,
  setSaveLoading,
  loadSuccess,
}) => {
  if (!loadSuccess) return;
  setLoadSuccess(false);
  setSaveLoading(true);
  toggleLeftPanel();
  let slideIDCopy = JSON.parse(JSON.stringify(slideID));
  let currentChildIndex = currentSlide?.child?.index - 1;
  let currentSlideCopy = JSON.parse(JSON.stringify(currentSlide));
  if (currentChildIndex > 0) {
    navigate(
      `/editor/${
        currentSlide.master.children[currentChildIndex - 1].slideid?._id
      }`
    );
    currentSlideCopy.child =
      currentSlideCopy.master.children[currentChildIndex - 1];

    setChildSlideCount(currentSlide?.master?.index + "." + currentChildIndex);
  } else { // if (currentChildIndex === 0) {
    navigate(`/editor/${currentSlide.master.slideid?._id}`);
    currentSlideCopy.child = {};
    setChildSlideCount(0);
    let currentMasterSlideIndex = getCurrentMasterSlideIndex(
      slideID,
      currentSlide
    );
    setSlideCount(currentMasterSlideIndex);
  }
  setCurrentSlide(currentSlideCopy);
  slideIDCopy[currentSlideCopy.master.index - 1] = currentSlideCopy.master;
  // console.log(slideIDCopy, 'iii', currentSlideCopy, 'ppp')
  setSlideID(slideIDCopy);
};
export const inParent = (currentSlide) => {
  return JSON.stringify(currentSlide?.child) === "{}";
};
export const lastChild = (currentSlide) => {
  const childslideid = currentSlide?.child?.slideid?._id;
  const child = currentSlide?.master?.children?.findIndex(li => li?.slideid?._id === childslideid);
  if(currentSlide?.master?.children?.length > child + 1) {
    return false;
  } else return true;
  // if (!currentSlide?.master?.children?.length) return true;
  // if (
  //   JSON.stringify(currentSlide?.child) !== "{}" &&
  //   currentSlide?.child?.index === currentSlide?.master?.children.length
  // )
  //   return true;
  // return false;
};
